/** Human-readable date for article bylines; falls back to raw if invalid. */
export function formatBlogDate(iso: string): string {
  const d = new Date(iso.trim());
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(d);
}
